module.exports = __webpack_public_path__ + "static/media/play-button.05f69e62.png";